import React, { useRef } from "react";
import { Menubar } from "primereact/menubar";
import { Chip } from "primereact/chip";
import { Menu } from "primereact/menu";
import useLogout from "../hooks/useLogout";
import { useNavigate } from "react-router-dom";

export default function Navbar({ Auth }) {
  const navigate = useNavigate();
  const menuRight = useRef(null);
  const logout = useLogout();

  const signOut = async () => {
    await logout();
    navigate("/login");
  };

  const optionsUser = [
    {
      label: "Opciones",
      items: [
        {
          label: "Editar",
          icon: "pi pi-user-edit",
           command: () => navigate('/perfil'),
        },
        {
          label: "Salir",
          icon: "pi pi-sign-out",
          command: () => signOut(),
        },
      ],
    },
  ];

  const items = [
    {
      label: "Inicio",
      icon: "pi pi-home",
      url: "/",
    },
    {
      label: "Carga de EBA",
      icon: "pi pi-upload",
      url: "/Cargar-EBA",
    },
    // {
    //   label: "Catálogos",
    //   icon: "pi pi-database",
    //   items: [
    //     { label: "Empresas", icon: "pi pi-briefcase", url: "/empresas" },
    //     { label: "Registros patronales", icon: "pi pi-book", url: "/regpatronales" },
    //     { label: "Afiliados", icon: "pi pi-users", url: "/afiliados" },
    //     { label: "Bimestres", icon: "pi pi-calendar", url: "/bimestres" },
    //   ],
    // },
    {
      label: "Recibos de nómina",
      icon: "pi pi-file-arrow-up",
      items: [
        { label: "Cargar XMLs", icon: "pi pi-upload", url: "/cfdis" },
        // { label: "Registros patronales", icon: "pi pi-book", url: "/regpatronales" },
        // { label: "Afiliados", icon: "pi pi-users", url: "/afiliados" },
        // { label: "Bimestres", icon: "pi pi-calendar", url: "/bimestres" },
      ],
    },
    {
      label: "Procesos",
      icon: "pi pi-cog",
      items: [
        { label: "Validación", icon: "pi pi-check", url: "/validar" },
        { separator: true },
        { label: "Confronta", icon: "pi pi-arrow-down-left-and-arrow-up-right-to-center", url: "/confronta" },
        { separator: true },
        { label: "confronta V2", icon: "pi pi-arrow-down-left-and-arrow-up-right-to-center", url: "/confrontaV2" },
        { separator: true },
         { label: "Enviar a SUA", icon: "pi pi-send", url: "/" },
      ],
    },
    {
      label: "Reportes",
      icon: "pi pi-file",
      items: [
        // { label: "Confronta", icon: "pi pi-sort-amount-down-alt", url: "/confronta" },
        // { separator: true },
        { label: "Confronta", icon: "pi pi-database", url: "/confronta/resultados" },
        { label: "CFDIs", icon: "pi pi-database", url: "/cfdis/resultados" },
      ],
    },
  ];

  const start = (
    <div className="flex align-items-center gap-2">
      <img src="/logo.png" alt="logo" height="30" />
      <span className="text-white font-bold text-lg">SUA - Utilities</span>
    </div>
  );

  const content = (
    <div className="flex align-items-center gap-2">
      <div
        className="bg-gray-700 text-white border-circle flex align-items-center justify-content-center"
        style={{ width: "2rem", height: "2rem", fontSize: "1rem", fontWeight: 600 }}
      >
        {Auth.nombre?.charAt(0).toUpperCase()}
      </div>
      <div className="flex flex-column text-white">
        <span style={{ lineHeight: 1 }}>{Auth.nombre}</span>
        {Auth.apellido && <span className="text-sm text-gray-300" style={{ lineHeight: 1 }}>{Auth.apellido}</span>}
      </div>
    </div>
  );

  const end = (
    <>
      <Menu model={optionsUser} popup ref={menuRight} id="popup_menu_right" popupAlignment="right" />
      <div
        className="flex align-items-center cursor-pointer px-2 py-1 border-round hover:bg-gray-800 transition-colors"
        onClick={(e) => menuRight.current.toggle(e)}
      >
        <Chip template={content} className="bg-gray-800 border-none px-2 py-1" />
      </div>
    </>
  );

  if (!Auth?.nombre) {
    return (
      <div className="bg-yellow-600 text-white p-3">⚠️ Cargando Navbar... Datos incompletos</div>
    );
  }
  return (
    <div className="surface-300">
      <Menubar
        model={items}
        start={start}
        end={end}
        className="border-none shadow-none surface-900 text-white px-3"
        
  //        pt={{
  //         menuitem: { className: 'text-white' },
  //         icon: { className: 'text-white' },
  //         label: { className: 'text-white' }
  // }}
      />
    </div>
  );
}
